/*
 * Copyright 2017 ebondu and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * A login iframe.
 */
export class LoginIframe {
    public iframe: any;
    public iframeOrigin: any;

    constructor(public enable: boolean, public callbackMap: any, public interval: number) {

    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/utils/keycloak.utils.loginIframe.ts